import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const GestorAnuncios = () => {
  // Datos falsos para anuncios y saldo
  const [anuncios, setAnuncios] = useState([
    {
      id: 1,
      nombre: 'Tienda de Ropa',
      descripcion: 'Ofrecemos ropa moderna para toda la familia.',
      url: 'http://www.tiendaderopa.com',
      media: 'https://marketplace.canva.com/EAGRXK0pWbI/1/0/400w/canva-JMwHgb1wWWo.jpg', // Imagen por defecto
      fechaInicio: '2023-09-01',
      visitas: 150,
      clics: 25,
      mediaType: 'image', // Para definir si es imagen o video
    },
    {
      id: 2,
      nombre: 'Pastelería Gourmet',
      descripcion: 'Pasteles y postres artesanales.',
      url: 'http://www.pasteleriagourmet.com',
      media: 'https://marketplace.canva.com/EAGFv0x31JQ/1/0/400w/canva-9iMFB8a5eIo.jpg', // Imagen por defecto
      fechaInicio: '2023-09-10',
      visitas: 250,
      clics: 40,
      mediaType: 'image',
    },
  ]);

  const [nuevoAnuncio, setNuevoAnuncio] = useState({
    nombre: '',
    descripcion: '',
    url: '',
    fechaInicio: '',
    media: null,
    mediaType: '', // Nuevo campo para tipo de archivo (imagen o video)
  });

  const [saldo, setSaldo] = useState(100.0); // Saldo actual
  const [showModal, setShowModal] = useState(false);

  // Función para abrir y cerrar el modal
  const handleModal = () => setShowModal(!showModal);

  // Función para manejar la subida de archivos
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file.type.split('/')[0]; // 'image' o 'video'
      setNuevoAnuncio({
        ...nuevoAnuncio,
        media: URL.createObjectURL(file), // Crea una URL local para previsualizar el archivo
        mediaType: fileType,
      });
    }
  };

  // Función para agregar un anuncio nuevo
  const agregarAnuncio = (e) => {
    e.preventDefault();
    const id = anuncios.length + 1;
    const visitas = 0; // Inicialmente sin visitas
    const clics = 0; // Inicialmente sin clics
    setAnuncios([...anuncios, { ...nuevoAnuncio, id, visitas, clics }]);
    setNuevoAnuncio({ nombre: '', descripcion: '', url: '', fechaInicio: '', media: null, mediaType: '' });
    handleModal(); // Cerrar modal después de agregar
  };

  // Función para recargar saldo
  const recargarSaldo = () => {
    const nuevoSaldo = saldo + 50; // Simulación de recarga
    setSaldo(nuevoSaldo);
  };

  return (
    <div className="container mt-5">
      <h2>Gestión de Anuncios</h2>

      {/* Mostrar saldo actual y opción de recargar */}
      <div className="mb-4">
        <h5>Saldo disponible: ${saldo.toFixed(2)}</h5>
        <Button variant="success" onClick={recargarSaldo}>Recargar Saldo</Button>
      </div>

      {/* Botón para abrir el modal de nuevo anuncio */}
      <Button variant="primary" onClick={handleModal}>Crear Nuevo Anuncio</Button>

      {/* Modal para el formulario de nuevo anuncio */}
      <Modal show={showModal} onHide={handleModal}>
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Anuncio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={agregarAnuncio}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre del Negocio</Form.Label>
              <Form.Control
                type="text"
                value={nuevoAnuncio.nombre}
                onChange={(e) => setNuevoAnuncio({ ...nuevoAnuncio, nombre: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Descripción del Negocio</Form.Label>
              <Form.Control
                as="textarea"
                value={nuevoAnuncio.descripcion}
                onChange={(e) => setNuevoAnuncio({ ...nuevoAnuncio, descripcion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>URL del Negocio</Form.Label>
              <Form.Control
                type="url"
                value={nuevoAnuncio.url}
                onChange={(e) => setNuevoAnuncio({ ...nuevoAnuncio, url: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Imagen o Video del Negocio (jpg, png, mp4)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*,video/mp4"
                onChange={handleFileUpload}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Fecha de Inicio</Form.Label>
              <Form.Control
                type="date"
                value={nuevoAnuncio.fechaInicio}
                onChange={(e) => setNuevoAnuncio({ ...nuevoAnuncio, fechaInicio: e.target.value })}
                required
              />
            </Form.Group>
            <Button type="submit" variant="primary">Agregar Anuncio</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Sección de los anuncios */}
      <h3 className="mt-4">Tus Anuncios</h3>
      <div className="row">
        {anuncios.map((anuncio) => (
          <div key={anuncio.id} className="col-md-4">
            <div className="card mb-4">
              {anuncio.mediaType === 'image' ? (
                <img src={anuncio.media} className="card-img-top" alt={anuncio.nombre} />
              ) : (
                <video controls className="card-img-top" alt={anuncio.nombre} style={{ maxHeight: '200px' }}>
                  <source src={anuncio.media} type="video/mp4" />
                </video>
              )}
              <div className="card-body">
                <h5 className="card-title">{anuncio.nombre}</h5>
                <p className="card-text">{anuncio.descripcion}</p>
                <p className="mb-2"><strong>Fecha de Inicio:</strong> {anuncio.fechaInicio}</p>
                <div className="d-flex justify-content-between">
                  <span><strong>Visitas:</strong> {anuncio.visitas}</span>
                  <span><strong>Clics:</strong> {anuncio.clics}</span>
                </div>
                <a href={anuncio.url} className="btn btn-primary mt-3" target="_blank" rel="noopener noreferrer">Visitar</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GestorAnuncios;
